/**
 * Dependencies.
 */
import de from './de';
import en from './en';
import es from './es';
import it from './it';
import pt from './pt';

/**
 * Export translations.
 */
export default {
  'de-DE': { SURVEY: de },
  'en-US': { SURVEY: en },
  'es-ES': { SURVEY: es },
  'it-IT': { SURVEY: it },
  'pt-PT': { SURVEY: pt }
};
